import { Injectable } from '@angular/core';
import { Contact } from './contact';
import { Customer } from './../customers/customers';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';


@Injectable({
  providedIn: 'root'
})


export class ContactsService {



  private baseURL = environment.baseUrl;

  private subject = new BehaviorSubject<Contact[]>([]);
  // observable for contacts grid
  gridContact$: Observable<Contact[]> = this.subject.asObservable();
  isLoading = true;


  constructor(private http: HttpClient, private messager: MessagerComponent ) { }

  init() {

    const contactsHttp$ = this.getContacts();
    contactsHttp$.pipe(
      map(res => res),
      tap((res) => {
        this.isLoading = false;

      })
    ).subscribe(
      res => this.subject.next(res.Contacts)
    );

  }

  getInitialContacts(){
    return this.gridContact$.pipe(
      map(contacts => contacts)
    );
  }

  deleteContact(contactId: number) {

    const contacts = this.subject.getValue();
    const contactIndex  = contacts.findIndex(contact => contact.id === contactId);
    const newContactList = contacts.slice(0);

    newContactList.splice(contactIndex, 1);
    this.subject.next(newContactList);

  }

  addHomeowner(customer_homeowner: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/contacts/addHomeowner', customer_homeowner, {observe: 'body'});
  }

  updateFutureContacts(contactId: number):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/contacts/updateScheduledContacts/' 
      + contactId, {observe: 'body'}); 
  }

  saveEditedContact(contactId: number, changes): Observable<any> {
    // first we update the front end optimistically and emit new value to
    // all subscribers

    // get a reference to the entire array
    const contacts = this.subject.getValue();
    // find the index of the contact passed in argument
    const contactIndex = contacts.findIndex(contact => contact.id === contactId);

    const newContactList = contacts.slice(0);

    newContactList[contactIndex] = {
      ...contacts[contactIndex],
      ...changes
    };

    this.subject.next(newContactList);
    return this.http.post(this.baseURL + '/rhAPI/contacts/edit/' + contactId, changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
          this.subject.next(contacts);
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    );
  }

  // Persist a contact's text-message preferences (Builder Confirmation feature).
  updateTextPreferences(id: number, prefs): Observable<any> {
    return this.http.put(this.baseURL + '/rhAPI/contacts/' + id + '/textPreferences', prefs, {observe: 'body'});
  }

  getOneContact(id): Observable<any> {

    return this.http.get(this.baseURL + '/rhAPI/contacts/edit/' + id).pipe(tap((event) => {
      const message = event.Message as unknown as string;
      if (event.Error) {
        this.messager.openSnackBar(message, 'Close', 'errorAlert');
      } else {
        this.messager.openSnackBar(message, 'Editing...', 'successAlert');
      }
    }));
  }

  getBaseURL = ()=> this.baseURL;



  addContact(changes): Observable<any> {
    // first we update the front end optimistically and emit new value to
    // all subscribers

    // get a reference to the entire array
    const contacts = this.subject.getValue();


    return this.http.post(this.baseURL + '/rhAPI/contacts/create', changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
          this.subject.next(contacts);
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    );

  }

  addOneFrontend(changes): void {

    const contacts = this.subject.getValue();

    const newContactList = contacts.slice(0);
    newContactList.unshift(changes);

    this.subject.next(newContactList);

  }


  // return all
  getContacts(): Observable<any> {
    return this.http.get<Contact[]>(this.baseURL + '/rhAPI/contacts', {observe: 'body'}).pipe(
      tap(event => {
        if (event.Error) {
          this.messager.openSnackBar(event.Message, '', 'errorAlert');
        }
      })
    );
  }



  // return a single contact (used for editing, etc)
  getSingleContact(id: number): Observable<Contact[]> {
    return this.http.get<Contact[]>(this.baseURL + '/rhAPI/contacts/edit/' + id);
  }

  // return CUSTOMERS for dropdown, filtered by string name
  getCustomersDropdown(name: string): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.baseURL + '/rhAPI/customers/' + name);
  }

  getContactsDropdown(name: string): Observable<Contact[]> {
    return this.http.get<Contact[]>(this.baseURL + '/rhAPI/getContactByName/' + name);
  }

  checkDuplicateContacts(name: string): Observable<any> {
    return this.http.get(
      `${this.baseURL}/rhAPI/contacts/checkDuplicateContacts/${name}`);
  }

}
